import { DISCUSSION_LIMITS, linkPreview } from 'lib/community/discussions-writer'
import styles from './Writer.module.css'

interface LinkBlockProps {
  url: string
  onChange: (value: string) => void
}

/**
 * A URL and, once it is a valid https link, the preview card: the domain and a title derived
 * from the URL's path. Nothing is fetched (no Open Graph in v1 — contract §0).
 */
const LinkBlock: React.VFC<LinkBlockProps> = ({ url, onChange }) => {
  const preview = linkPreview(url)
  return (
    <div className={styles.link}>
      <div className={styles.linkRow}>
        <span className={styles.linkIcon} aria-hidden="true">
          {'🔗'}
        </span>
        <input
          className={styles.linkInput}
          type="url"
          inputMode="url"
          value={url}
          maxLength={DISCUSSION_LIMITS.urlChars}
          placeholder="Paste a link"
          aria-label="Link"
          onChange={e => onChange(e.target.value)}
        />
      </div>
      {preview && (
        <div className={styles.linkPreview}>
          <span className={styles.linkThumb} aria-hidden="true" />
          <span className={styles.linkText}>
            <span className={styles.linkDomain}>{preview.domain.toUpperCase()}</span>
            <span className={styles.linkTitle}>{preview.title ?? preview.domain}</span>
          </span>
        </div>
      )}
      {!preview && url.trim() && (
        <p className={styles.linkHint}>{'Paste a full link that starts with https://'}</p>
      )}
    </div>
  )
}

export default LinkBlock
